export default {
  route: {
    dashboard: '首页',
    introduction: '简述',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    menu1: '菜单1',
    'menu1-1': '菜单1-1',
    'menu1-2': '菜单1-2',
    'menu1-2-1': '菜单1-2-1',
    'menu1-2-2': '菜单1-2-2',
    'menu1-3': '菜单1-3',
    menu2: '菜单2',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Table内编辑',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    company: '车队客户',
    manager: '车队管理',
    grade: '等级管理',
    customer: '客户管理',
    setting: '设置',
    pay: '支付方式',
    card: '卡片库存',
    retail: '散户管理',
    childMember: '子账号管理',
    record: '数据查询',
    fuel: '加油记录',
    amount: '资金明细',
    point: '积分记录',
    charge: '充值记录',
    refund: '退款记录',
    close: '销户记录',
    reportForms: '日报表',
    station: '站点管理',
    feulList: '油站列表',
    listFp: '油枪列表',
    listTank: '油罐列表',
    emp: '员工管理',
    stockManage: '库存管理',
    nowStock: '当前库存',
    inOilRecord: '进油记录',
    video: '视频',
    videoList: '视频监控'

  },
  seting: {
    payTypeName: '支付名称',
    empName: '员工姓名',
    title: '员工职位',
    stationName: '所属站点',
    phoneNum: '员工电话',
    loginPwd: '登陆密码',
    isAdmin: '是否所有权限',
    isAllStation: '允许所有站点',
    allowStations: '允许站点',
    empType: '类型',
    cardNo: '卡号'
  },
  station: {
    stationId: '站点ID',
    stationName: '站点名称',
    contactName: '联系人',
    contactPhone: '联系电话',
    isActivated: '是否激活',
    activationTime: '激活时间'
  },
  amount: {
    amtTypeName: '交易类型',
    companyName: '车队名称',
    createdTime: '时间',
    optStationName: '站点名称',
    amt: '退款金额',
    memo: '备注',
    balanceAmt: '余额'
  },
  record: {
    cardNo: '客户卡号',
    fpNo: '枪号',
    prodName: '油品',
    price: '单价',
    receAmt: '升数',
    shiftNo: '班次号',
    payStatus: '支付状态',
    payTypeName: '支付方式',
    createdTime: '开始时间',
    empId: '加油员',
    fuelOrderId: '订单号',
    beginTime: '开始时间',
    endTime: '结束时间',
    amtType: '类型'
  },
  member: {
    memberId: '会员ID',
    memberType: '客户类型',
    memberName: '会员名称',
    phoneNum: '联系电话',
    carNo: '车牌',
    birthday: '生日',
    idCard: '身份证',
    memo: '备注',
    cardNo: '卡号',
    point: '积分',
    frozenAmt: '预授权',
    balanceAmt: '余额',
    createdTime: '开户时间',
    timesUpperLimit: '单次限额(元)',
    dailyUpperLimit: '单日限额(元)',
    monthUpperLimit: '单月限额(元)',
    checkCarNo: '校验车牌',
    checkEmpCard: '校验员工卡',
    checkFuelPwd: '校验加油密码',
    fuelPwd: '加油密码',
    isAllFuel: '支持所有站点消费',
    fuelStations: '允许站点',
    isAllCharge: '支持所有站点充值',
    chargeStations: '允许站点'
  },
  company: {
    companyId: '车队ID',
    companyName: '车队名称',
    contactName: '联系人',
    contactPhone: '联系电话',
    memberGrade: '会员等级',
    memberGradeName: '会员等级',
    companyType: '付款方式',
    creditAmt: '透支额度',
    address: '地址',
    email: '电子邮件',
    point: '积分',
    frozenAmt: '预授权',
    balanceAmt: '余额',
    station: '开户站点',
    optStationName: '开户站点',
    createdTime: '开户时间',
    amt: '充值金额',
    ramt: '退款金额',
    giftAmt: '赠送金额',
    payType: '支付方式',
    memo: '备注'
  },
  grade: {
    gradeName: '等级名称',
    petrolSaleAmt: '汽油每升优惠',
    petrolPoint: '汽油每一元积分',
    dieselSaleAmt: '柴油每升优惠',
    dieselPoint: '柴油每一元积分',
    createdTime: '创建时间',
    updatedTime: '更新时间',
    status: '状态'
  },
  card: {
    lgcCardNo: '逻辑卡号',
    phyCardNo: '物理卡号',
    groupName: '集团名称',
    stationName: '站点名称',
    usedStatus: '使用状态',
    createdTime: '导入时间',
    updatedTime: '更新时间'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips:
      '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description:
      '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}
